<template>
    <div class="container pt-lg-5">
        <h1>Galeria</h1>
        <hr>
        <div class="row">
            <gallery-card v-for="gallery in galleries" :gallery="gallery" :key="gallery.slug"/>
        </div>
    </div>
</template>

<script>
import Galleries from './../galleries.js';
import GalleryCard from './../components/GalleryCard';

export default {
  components: {
    GalleryCard,
  },
  data() {
    return {
      galleries: Galleries.galeries(),
    };
  },
};
</script>

<style lang="scss">

    .col {
        padding-bottom: 20px;
    }
</style>
